module.exports = __webpack_public_path__ + "static/img/g1.01a603d.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/3/4/2/eng/g1.png
// module id = DUao
// module chunks = 0